import { Button } from "@/components/ui/button";

interface VehicleItem {
  label: string;
  img: string;
}

const vehicles: VehicleItem[] = [
  { label: "Carros", img: "/images/customer/car.svg" },
  { label: "Barcos", img: "/images/customer/boat.svg" },
  { label: "Motos", img: "/images/customer/motorcycle.svg" },
];

interface OtherVehiclesCardProps {
  onSelect?: (vehicle: string) => void;
}

const OtherVehiclesCard = ({ onSelect }: OtherVehiclesCardProps) => (
  <div className="bg-white rounded-2xl shadow-sm p-6 border border-gray-200">
    <h2 className="text-xl font-semibold text-n-green mb-4">
      Transporte outros tipos de veículos:
    </h2>

    <div className="flex gap-4 overflow-x-auto pb-2">
      {vehicles.map(({ label, img }) => (
        <Button
          key={label}
          variant="ghost"
          onClick={() => onSelect?.(label)}
          className="flex flex-col items-center gap-2 min-w-[140px] h-auto p-4 bg-white border border-gray-300 rounded-2xl hover:shadow transition hover:bg-white"
        >
          <img
            src={img}
            alt={label}
            className="w-24 h-24 object-contain"
            loading="lazy"
          />
          <span className="text-base font-medium text-n-green">{label}</span>
        </Button>
      ))}
    </div>
  </div>
);

export default OtherVehiclesCard;